import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
// import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getSerialCategory(params) {
	return client.get("transaksi/serial/category", {
		params: params,
	});
}

function getSerialMembership(params) {
	return client.get("binary/serial/all", {
		params: params,
	});
}

function getDetailSerialMembership(params) {
	return client.get("binary/serial/detail-membership", {
		params: {
			serial_id : params
		},
	});
}

function getSerialRegistration(params) {
	return client.get("binary/serial/all", {
		params: params,
	});
}

function getDetailSerialRegistration(params) {
	return client.get("binary/serial/detail-registration", {
		params: {
			serial_id : params
		},
	});
}

// all serial
function getAllAvaSerial(params) {
	return client.get("binary/serial/available", {
		params: params
	});
}

// serial membership
function getSerialAvaMember(params) {
	const authData = localStorage.getItem('mlmcore-vo-auth-data');
	const data = JSON.parse(authData);
	
	if (!data.bin_network_id) {
		return client.get("membership/serial/my-serial", {
			params: params,
		});
	} else {
		return client.get("binary/serial/available", {
			params: params,
		});
	}
}

// serial registrasi
function getSerialAvaRegis(params) {
	return client.get("binary/serial/available", {
		params: params
	});
}

// serial my serial available
function getSerialAvailable(params) {
	const authData = localStorage.getItem('mlmcore-vo-auth-data');
	const data = JSON.parse(authData);
	
	if (!data.bin_network_id) {
		return client.get("membership/serial/my-serial", {
			params: params,
		});
	} else {
		return client.get("binary/serial/my-serial", {
			params: params,
		});
	}
}

function getSerialAvailableMitra(params) {
	return client.get("binary/serial/my-serial", {
		params: params,
	});
}

function getSerialAvailablePramitra(params) {
	return client.get("membership/serial/my-serial", {
		params: params,
	});
}

export default {
	getSerialCategory,
	getSerialMembership,
	getDetailSerialMembership,
	getSerialRegistration,
	getDetailSerialRegistration,
	getAllAvaSerial,
	getSerialAvaMember,
	getSerialAvaRegis,
	getSerialAvailable,
	getSerialAvailableMitra,
	getSerialAvailablePramitra
};